import { connect } from 'react-redux';
import { createSession, clearCreateSessionErrorMessage } from '../redux/actions/createSession';
import { setSearchBookingDataFromCookie, clearBookingSearchErrorMessage, setShowAppModal } from '../redux/actions/bookingSearch';
import CustomRoute from '../components/customRoute/CustomRoute';
import { clearAvailableAddonsErrorMessage } from '../redux/actions/dinings';
import { clearSaveAddonErrorMessage } from '../redux/actions/changeAddon';
import { clearAvailableEntertainmentsError } from '../redux/actions/availableEntertainments';
import getConfig from '../redux/actions/getConfig';
import { clearArrivalTimeError } from '../redux/actions/arrivalTime';
import { getNothingToBookMessage, getIfAllowedToBook, checkIsConfigNeedsToBeRefreshed } from '../utils';

const getIsFetching = (
  { isFetching: bookingIsFetching },
  { isFetching: availableAddonsIsFetching },
  { isFetching: saveAddonsIsFetching },
  { isFetching: sessionCreationIsFetching },
  { isFetching: availableEntertainmentsIsFetching },
  { isFetching: bookedEntertainmentsIsFetching },
  { isFetching: arrivalTimeIsFetching },
) => bookingIsFetching
  || availableAddonsIsFetching
  || saveAddonsIsFetching
  || sessionCreationIsFetching
  || availableEntertainmentsIsFetching
  || bookedEntertainmentsIsFetching
  || arrivalTimeIsFetching;

const getNothingToBookErrorMessage = (
  { wasCalled: getAvailableAddonsWasCalled, bookedBreakfast, bookedDinner },
  { wasCalled: getAvailableEntertainmentsWasCalled, entertainments },
) => {
  const wasEverythingSkipped = getAvailableAddonsWasCalled
    && getAvailableEntertainmentsWasCalled
    && (!bookedDinner || !bookedDinner.AddonCategory)
    && (!bookedBreakfast || !bookedBreakfast.AddonCategory)
    && (!entertainments || entertainments.length === 0);

  return wasEverythingSkipped ? getNothingToBookMessage() : '';
};

const getShowAppLinks = (bookingSearch, config, arrivalTimeSlots, isDineAroundPage, isSwimmingPage, isEntertainmentPage) => {
  if (bookingSearch.showAppModal) return true;
  const { isAllowedToBookDineAround, isAllowedToBookEntertainment, isAllowedToBookSwimming } = getIfAllowedToBook(bookingSearch, config);
  if (isDineAroundPage) return !isAllowedToBookDineAround;
  if (isSwimmingPage) return !isAllowedToBookSwimming;
  if (isEntertainmentPage) return !isAllowedToBookEntertainment;
  return !isAllowedToBookDineAround && !isAllowedToBookEntertainment && !isAllowedToBookSwimming && arrivalTimeSlots.length === 0;
};

const mapStateToProps = ({
  bookingSearch,
  dinings,
  changeAddon,
  sessionCreation,
  availableEntertainments,
  bookedEntertainments,
  config,
  arrivalTime,
}, { children, privateRoute, notFoundErrorMessage, isDineAroundPage, isSwimmingPage, isEntertainmentPage }) => {
  const { arrivalTimeSlots = [] } = arrivalTime;
  return {
    children,
    privateRoute,
    bookingErrorMessage: bookingSearch.errorMessage,
    availableAddonsErrorMessage: dinings.errorMessage,
    saveAddonErrorMessage: changeAddon.errorMessage,
    sessionCreationErrorMessage: sessionCreation.errorMessage,
    availableEntertainmentsErrorMessage: availableEntertainments.errorMessage,
    arrivalTimeErrorMessage: arrivalTime.errorMessage,
    isFetching: getIsFetching(bookingSearch, dinings, changeAddon, sessionCreation, availableEntertainments, bookedEntertainments, arrivalTime),
    nothingToBookErrorMessage: getNothingToBookErrorMessage(dinings, availableEntertainments),
    notFoundErrorMessage,
    maxEntertainmentSlotsLessThan7Nights: parseInt(config.REACT_APP_MAX_ENTERTAINMENT_SLOTS_LESS_THAN_7_NIGHTS, 10) || 1,
    maxEntertainmentSlotsMoreThanOrEqual7Nights: parseInt(config.REACT_APP_MAX_ENTERTAINMENT_SLOTS_MORE_THAN_OR_EQUAL_7_NIGHTS, 10) || 2,
    bookingPrefix: config.REACT_APP_BOOKING_PREFIX,
    showAppLinks: getShowAppLinks(bookingSearch, config, arrivalTimeSlots, isDineAroundPage, isSwimmingPage, isEntertainmentPage),
    playStoreLink: config[`REACT_APP_PLAY_STORE_${bookingSearch.siteCode.toUpperCase()}`],
    appStoreLink: config[`REACT_APP_APP_STORE_${bookingSearch.siteCode.toUpperCase()}`],
    resortMessage: config[`REACT_APP_REPLACED_BY_APP_${bookingSearch.siteCode.toUpperCase()}`],
    isReloadNecessary: checkIsConfigNeedsToBeRefreshed(config.lastConfigCheckDateTime, parseInt(config.REACT_APP_REFRESH_TIME_INTERVAL, 10) || 15),
  };
};

const mapDispatchToProps = dispatch => ({
  createSession: () => dispatch(createSession()),
  setDataFromCookie: params => dispatch(setSearchBookingDataFromCookie(params)),
  clearBookingSearchErrorMessage: () => dispatch(clearBookingSearchErrorMessage()),
  clearAvailableAddonsErrorMessage: () => dispatch(clearAvailableAddonsErrorMessage()),
  clearSaveAddonErrorMessage: () => dispatch(clearSaveAddonErrorMessage()),
  clearCreateSessionErrorMessage: () => dispatch(clearCreateSessionErrorMessage()),
  clearAvailableEntertainmentsErrorMessage: () => dispatch(clearAvailableEntertainmentsError()),
  clearArrivalTimeErrorMessage: () => dispatch(clearArrivalTimeError()),
  getConfig: () => dispatch(getConfig()),
  setShowAppModal: showAppModal => dispatch(setShowAppModal(showAppModal)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomRoute);
